import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import Select from "react-select";
import {
  changeLanguage,
  languageChange,
} from "../pages/OrganizationCustomer/actions";
import { LOGOUT_URL } from "../config/config";

function Header(props) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [username, setUsername] = useState("");
  const [trans, i18n] = useTranslation("language");
  const [lang] = useTranslation("language");
  const [path, setPath] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const { language, name } = props;
  const token = sessionStorage.getItem("token");

  const options1 = [
    { value: "en", label: `${lang("Language.english")}` },
    { value: "jp", label: `${lang("Language.japan")}` },
  ];

  useEffect(() => {
    let path = window.location.pathname;
    setPath(path);
    i18n.changeLanguage(props.language);
    const name = sessionStorage.getItem("Username");
    setUsername(name);
    const currentLang = sessionStorage.getItem("Language");
    setSelectedLanguage(currentLang);
    if (window.screen.width <= 767) {
      setIsOpen(false);
    }
    if (["/organizationInfo", "/personInfo","/reception","/parent"].includes(path)) {
      setIsOpen(false);
    }
  }, [language]);

  const sidebar = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      document.body.classList.add("sidebar-collapse");
    } else {
      document.body.classList.add("sidebar-open");
      document.body.classList.remove("sidebar-collapse");
    }
  };

  const handleLanguageChange = async (value) => {
    let body = {
      wwid: sessionStorage.getItem("WWID"),
      language: value.value,
    };
    sessionStorage.setItem("Language", value.value);
    let language = value.value;
    const data = {
      language: language,
    };
    props.changeLanguage(data);
    i18n.changeLanguage(language);
    await languageChange(body).then((response) => {});
  };

  const handleLogout = () => {
    sessionStorage.setItem("token", "");
    sessionStorage.setItem("User role", "");
    sessionStorage.setItem("Username", "");
    sessionStorage.setItem("salesOfficeID", "");
    sessionStorage.setItem("buID", "");
    sessionStorage.setItem("divisionID", "");
    sessionStorage.setItem("branchId", "");
    window.location.assign(`${LOGOUT_URL}?token=${token}`)
  };

  return (
    <header className="site-header">
      <div className="header-menu-logo">
        <div className="site-hamburger-menu">
          <a className="humburger-menu" onClick={sidebar}>
            <em className="bx bx-menu"></em>
          </a>
        </div>
        <div className="site-logo">
          <img src="images/idiscoverportal-logo.svg" alt="site logo" />
        </div>
        <div className="jnj-logo">
          <img src="images/jnjim-logo.svg" alt="branding logo" />
        </div>
      </div>
      <div className="header-content">
        <a></a>
        <div className="header-right">
          <Select
            className="react-select lang-dropdown"
            options={options1}
            onChange={handleLanguageChange}
            placeholder="English"
            value={
              selectedLanguage === "jp"
                ? { value: "jp", label: `${lang("Language.japan")}` }
                : { value: "en", label: `${lang("Language.english")}` }
            }
          />
          <Dropdown className="header-dropdown">
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              <img src="images/images.jpeg" alt="avatar" />
              <a>{props.name ? props.name : username}</a>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => navigate("/downloads")}>
                {lang("Menu.downloads")}
              </Dropdown.Item>
              <Dropdown.Item onClick={handleLogout}>
                {lang("Menu.logout")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      {/* } */}
    </header>
  );
}

const mapStateToProps = (state) => ({
  language: state.organizationCustomer.language,
});

export default connect(mapStateToProps, { changeLanguage })(Header);